import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      securityQuestion1Options: [
        {
          text: 'What street did you grow up on?',
          value: 1,
        },
        {
          text: 'Where did you go to high school?',
          value: 2,
        },
        {
          text: 'Where does your closest sibling live?',
          value: 3,
        },
        {
          text: 'What school did you attend in sixth grade?',
          value: 4,
        },
        {
          text: 'What city were you born in?',
          value: 5,
        },
        {
          text: 'Where was your wedding reception held?',
          value: 6,
        },
        {
          text: 'In what city did your mother and father meet?',
          value: 7,
        },
        {
          text: 'In what city was your first job?',
          value: 8,
        },
        {
          text: 'I want to create my own question.',
          value: '*',
        },
      ],
      securityQuestion2Options: [
        {
          text: 'What is your favorite place to vacation?',
          value: 1,
        },
        {
          text: 'What is your favorite book?',
          value: 2,
        },
        {
          text: 'What was your childhood phone number?',
          value: 3,
        },
        {
          text: 'Where did you meet your spouse/significant other?',
          value: 4,
        },
        {
          text: 'What was the first company that you worked for?',
          value: 5,
        },
        {
          text: 'When is your oldest brother’s birthday?',
          value: 6,
        },
        {
          text: 'What was the name of your first stuffed animal?',
          value: 7,
        },
        {
          text: 'What is the name of your favorite pet?',
          value: 8,
        },
        {
          text: '	I want to create my own question.',
          value: '*',
        },
      ],
      securityQuestion3Options: [
        {
          text: 'What is the middle name of your oldest sibling?',
          value: 1,
        },
        {
          text: 'What is the name of your favorite cousin?',
          value: 2,
        },
        {
          text: 'What was your childhood nickname?',
          value: 3,
        },
        {
          text: 'What is the name of your favorite childhood friend?',
          value: 4,
        },
        {
          text: 'What is the middle name of your oldest child?',
          value: 5,
        },
        {
          text: 'What is the name of your college roommate?',
          value: 6,
        },
        {
          text: 'What was the last name of your third grade teacher?',
          value: 7,
        },
        {
          text: 'What is the maiden name of your maternal grandmother?',
          value: 8,
        },
        {
          text: 'I want to create my own question.',
          value: '*',
        },
      ],
    };
  },
});
